import axios from 'axios'

const api = axios.create({
  baseURL: `https://${import.meta.env.VITE_APP_DOMAIN}`,
  timeout: 60000,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

export default api
